<template>
  <section class="stars">
    <span
      v-for="i in 5"
      :key="i"
      :value="localRating"
      :class="{ 'star-clickable': interactive }"
      @click="onClick(i)"
    >
      <LsIcon
        :test-id="`star-${i}`"
        type="star"
        :size="size"
        :color="i <= localRating ? 'primary' : 'primary-light'"
      />
    </span>
  </section>
</template>

<script>
import LsIcon from '@/components/common/LsIcon/LsIcon.vue';
import { lsPropTypeHelpers, lsTrackingService } from 'ls-vue-common';
import VueTypes from 'vue-types';

export default {
  name: 'LsStars',
  components: {
    LsIcon,
  },
  props: {
    trackId: VueTypes.custom(lsPropTypeHelpers.trackID).isRequired,
    value: VueTypes.number.isRequired,
    interactive: VueTypes.bool.def(false),
    size: VueTypes.string.def('sm'),
  },
  data() {
    return {
      localRating: this.value,
    };
  },
  methods: {
    onClick(rating) {
      if (!this.interactive || this.localRating === rating) {
        return;
      }
      lsTrackingService.track({
        event: 'click',
        target: this.trackId,
        data: { value: rating },
      });
      this.localRating = rating;
      this.$emit('input', rating);
    },
  },
};
</script>

<style lang="scss" scoped>
.star-clickable {
  cursor: pointer;
}
</style>
